import { useStaticQuery, graphql } from 'gatsby';

const useDynamicHeroImages = () => {
  const { allContentfulImage } = useStaticQuery(
    graphql`
      query {
        allContentfulImage(
          filter: {
            contentful_id: {
              in: [
                "4cmbjg6gLkwPqlEyjh35ts" #bg-main-Sky-Blue
                "1495f0LuHprVidWlYKVkuU" #bg-main-White
                "RRDSN31hIl6gLin4qTAfL" #bg-main-Prussian
                "32gRHoDZlO4nVjVCQ9QweN" #bg-main-Azure
                "CsmFL9cUG5lF6g9wJK9vJ" #Software Advice Black
                "1BCz8kg8isBnEazo3RyezT" #Google Black
                "2OvSHiJkjSVL1VB48kbmli" #Capterra Black
                "7n9xWOg3bq62jNFOGlwOUz" #Google White (2)
                "4Hv9OEOfQi7cgyPqVdGkzE" #Capterra White (2)
                "7Dg7v6YoqGBSDhLf8wEdaL" #Software Advice White (2)
                "zfuZ1a10xSALJUMgmOqJH" #bg-roi-01
                "71RYtw7vbSRR2lxqFqijbi" #bg-main-white-short
              ]
            }
          }
        ) {
          edges {
            node {
              contentful_id
              internalName
              alt
              image {
                file {
                  url
                }
              }
            }
          }
        }
      }
    `
  );
  return allContentfulImage.edges;
};

export const useDynamicHeroImage = internalName => {
  const heroImages = useDynamicHeroImages();
  const image = heroImages
    .filter(imageItem => imageItem.node.internalName === internalName)
    .map(imageItem => imageItem.node.image);
  return image.length > 0 ? image[0] : null;
};

export default useDynamicHeroImages;
